import { pipe } from 'ramda';

import { request } from '@/api/base';
import { buildCmsUrl, getResponseCMS } from '@/api/cms/base';
import { getResponseCamelization } from '@/helpers/api';

export interface ITournamentGame {
  tournamentGameCategories?: string;
  tournamentGameIds?: string;
}

export const tournamentGame = () =>
  request<ITournamentGame>({
    url: buildCmsUrl({ path: 'tournament-game' }),
    transformResponse: pipe(
      getResponseCamelization,
      getResponseCMS<ITournamentGame>
    ),
  });
